import { AddWeekPayload } from './../../models/service';
import useLanguageCode from 'src/hooks/useLanguageCode';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { QUERY_KEYS } from 'src/enums';
import { addWeek } from 'src/services/api';

const useAddWeek = () => {
  const client = useQueryClient();
  const { lang } = useLanguageCode();

  const { mutate, isLoading } = useMutation<{ success?: boolean }, AxiosError, AddWeekPayload>(
    ['add-week'],
    (payload) => addWeek(payload, lang),
    {
      onSettled: () => {
        client.invalidateQueries([QUERY_KEYS.SYLLABUS]);
      }
    }
  );

  return {
    mutate,
    isLoading
  };
};

export default useAddWeek;
